import { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { useTheme } from '../../../../contexts/ThemeContext';

const AltColChart = ({ data, title, height }) => {
  const { theme } = useTheme();
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    const labelColor = theme === 'dark' ? '#d1d5db' : '#6b7280';
    renderChart(labelColor);
  }, [theme, data]);

  const renderChart = (labelColor) => {
    // Ensure data is in the format: { scope1: [12], scope2: [12], scope3: [12] }
    const series = [
      {
        name: 'Scope 1',
        data: data?.scope1 || Array(12).fill(0),
        color: '#F89C74',
      },
      {
        name: 'Scope 2',
        data: data?.scope2 || Array(12).fill(0),
        color: '#66C5CC',
      },
      {
        name: 'Scope 3',
        data: data?.scope3 || Array(12).fill(0),
        color: '#8BE0A4',
      },
    ];

    setChartData({
      series,
      options: {
        chart: {
          fontFamily: 'DM Sans, sans-serif',
          stacked: true,
          toolbar: { show: false },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '80%',
            endingShape: 'rounded',
          },
        },
        legend: {
          show: true,
          position: 'right',
          horizontalAlign: 'center',
          floating: false,
          fontSize: '14px',
          fontFamily: 'Inter',
          fontWeight: 400,
          labels: { colors: labelColor, useSeriesColors: true },
        },
        dataLabels: {
          enabled: false, // hide numbers on bars
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        colors: ['#F89C74', '#66C5CC', '#8BE0A4', '#DCB0F2', '#F6CF71'],
        xaxis: {
          categories: [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
          ],
          labels: { style: { colors: labelColor } },
          title: {
            text: 'Months',
            style: { color: labelColor, fontWeight: '500', fontSize: '12px' },
          },
        },
        yaxis: {
          labels: {
            formatter: (val) => Number(val).toFixed(2),
            style: { colors: labelColor },
          },
          title: {
            text: 'Tonnes of CO2',
            style: { color: labelColor, fontWeight: '500', fontSize: '14px' },
          },
        },
        tooltip: {
          y: {
            formatter: (val) => Number(val).toFixed(2) + ' kg CO2',
          },
        },
        fill: { opacity: 1 },
        responsive: [
          {
            breakpoint: 480,
            options: { legend: { position: 'bottom', offsetX: -10, offsetY: 0 } },
          },
        ],
      },
    });
  };

  return (
    <div className="overflow-hidden sm:rounded-lg bg-white dark:bg-darkbg4 px-4 py-6 border">
      <h3 className="text-left px-6">{title}</h3>
      {chartData && (
        <Chart options={chartData.options} series={chartData.series} type="bar" height={height} />
      )}
    </div>
  );
};

export default AltColChart;
